<template>
  <div class="flex min-h-screen w-full flex-col justify-between pt-navbar-height">
    <NuxtErrorBoundary>
      <AppNavigation />
    </NuxtErrorBoundary>

    <NuxtErrorBoundary>
      <main class="my-[15vh] flex flex-1 flex-col items-center justify-center">
        <h1 class="mx-auto font-bold typo-heading-2xl">
          {{ error.statusCode }}
        </h1>
        <h2 class="mx-auto mb-7 mt-4 max-w-xl typo-body-xl">
          {{
            props.error.statusCode === 404 ? $t('error.404') : $t('error.500')
          }}
        </h2>

        <!-- LINK -->
        <AppButton
          type="button"
          :aria-label="$t('error.backToHomepage')"

          @click="handleError(localePath('/'))"
        >
          <I18nT
            tag="span"
            keypath="error.backToHomepage"
          />
        </AppButton>

        <DevOnly v-if="false">
          <Container
            v-if="error"
            class="mb-32 mt-20 w-full"
          >
            <div class="relative overflow-scroll bg-white p-8">
              <p class="rounded bg-[#ffb5b5] px-6 py-3 font-[system-ui] text-xl font-semibold">
                {{ errorMessage }}
              </p>

              <div class="mt-2 rounded bg-[#e5e7eb] p-6">
                <template v-if="gqlErrorData">
                  <p class="font-semibold">
                    {{ gqlErrorData.extensions?.debugMessage }}
                  </p>
                  <div v-if="gqlErrorData.extensions">
                    <p v-if="gqlErrorData.extensions?.line">
                      {{ gqlErrorData.extensions?.file }}
                      <span> - Line: {{ gqlErrorData.extensions?.line }} </span>
                    </p>
                    <p v-if="gqlErrorData.extensions?.validation">
                      {{ gqlErrorData.extensions?.validation }}
                    </p>
                  </div>
                </template>
                <template v-else>
                  <pre wrap>{{ error.message }}</pre>

                  <p class="mt-4 inline-block rounded bg-white px-3 py-1 font-[system-ui] text-sm">
                    You might want to check your console log for more
                    information.
                  </p>
                </template>
              </div>

              <template v-if="error.statusCode === 500">
                <p class="mt-10 rounded bg-[#ffb5b5] px-6 py-3 font-[system-ui] text-xl font-semibold">
                  Stack
                </p>
                <div class="mt-2 overflow-auto rounded bg-[#e5e7eb] p-6">
                  <ul v-if="gqlErrorData?.extensions?.trace">
                    <li
                      v-for="(trace, index) in gqlErrorData?.extensions?.trace"
                      :key="index"
                    >
                      {{ trace.file }}
                    </li>
                  </ul>
                  <pre
                    v-else
                    wrap
                    v-html="error.stack"
                  />
                </div>
              </template>
            </div>
          </Container>
        </DevOnly>
      </main>
    </NuxtErrorBoundary>

    <NuxtErrorBoundary>
      <AppFooter />
    </NuxtErrorBoundary>
  </div>
</template>

<script setup lang="ts">
if (import.meta.client) {
  document.body.classList.add(useIsTouchDevice() ? 'is-touch' : 'no-touch')
}

const props = defineProps<{
  error: any
}>()

try {
  provide(GlobalsKey, await useInjectableGlobals())
} catch (error) {
  console.error('[ERROR Page]: Could not load globals', error)
}

const handleError = (uri: string) => {
  clearError({
    redirect: uri,
  })
}

const localePath = useLocalePath()

const gqlErrorData = computed(() => {
  if (!props.error.data) return null

  return JSON.parse(props.error.data)
})

const errorMessage = computed(() => {
  if (!gqlErrorData.value) return props.error.statusMessage

  return `${props.error.statusMessage} - ${gqlErrorData.value.message}`
})
</script>
